import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

interface ILabel {
  ID: number;
  TEXT: string;
}

interface IEmailFilterParameter {
  dateTo: number;
  dateFrom: number;
  searchText: string;
  maxRowCount: number;
  selectedLables: number[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailSearch',
  props: {
    labels: null,
    maxRowCount: null,
    autoSearch: { type: Boolean }
  },
  emits: ["email-filter-parameters-changed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'email-filter-parameters-changed', payload: IEmailFilterParameter): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  labels: ILabel[];
  maxRowCount: number;
  autoSearch?: boolean;
};





const toDate = ref('');
const fromDate = ref('');
const textValue = ref('');
const selectedLables = ref<any>([]);
const maxRowCount = ref(props.maxRowCount);

const doSearch = () => {
  const emailFilterParameters: IEmailFilterParameter = {
    maxRowCount: maxRowCount.value || 1,
    selectedLables: selectedLables.value,
    dateTo: new Date(toDate.value).getTime(),
    searchText: textValue.value?.toLowerCase(),
    dateFrom: new Date(fromDate.value).getTime(),
  };
  emit('email-filter-parameters-changed', emailFilterParameters);
};

const doAutoSearch = () => {
  if (props.autoSearch) {
    doSearch();
  }
};

return { __sfc: true,props, emit, toDate, fromDate, textValue, selectedLables, maxRowCount, doSearch, doAutoSearch }
}

})